var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
var PriorityIndicator = function (props) {
    switch (props.priority) {
        case "none": return null;
        case "high": return (_jsx("div", __assign({ style: {
                border: "2px solid #F43F5F",
                borderRadius: "14.25px",
                fontWeight: "bold",
                fontSize: 14,
                color: "#F43F5F",
                padding: "4px 15px"
            } }, { children: "Wichtig" })));
        case "severe": return (_jsx("div", __assign({ style: {
                background: "#F43F5F",
                borderRadius: "12.25px",
                fontWeight: "bold",
                fontSize: 14,
                color: "#FFFFFF",
                padding: "4px 15px"
            } }, { children: "Priorisiert" })));
    }
};
export default PriorityIndicator;
